import { useConnection } from 'hooks/useConnection'
import { useResolveCurrencyAddress } from 'hooks/useResolveCurrencyAddress'
import { Navigate, useParams } from 'react-router-dom'
import { isNativeCurrencyId } from 'utils/currencyId'

import AddLiquidityV2 from './index'

export function RedirectDuplicateTokenIdsV2() {
  const { currencyIdA, currencyIdB } = useParams<{ currencyIdA: string; currencyIdB: string }>()
  const { chainId } = useConnection()

  const currencyAAdress = useResolveCurrencyAddress(currencyIdA)
  const currencyBAdress = useResolveCurrencyAddress(currencyIdB)

  if (
    currencyIdA &&
    currencyIdB &&
    (currencyAAdress === currencyBAdress ||
      (isNativeCurrencyId(currencyIdA, chainId) && isNativeCurrencyId(currencyIdB, chainId)))
  ) {
    return <Navigate to={`/liquidity/v2/add/${currencyIdA}`} replace />
  }

  return <AddLiquidityV2 />
}
